// extracted by mini-css-extract-plugin
export default {"ProjectSectionMain":"ProjectSection_ProjectSectionMain__4-gyf","ProjectSection":"ProjectSection_ProjectSection__BYDMX","heading":"ProjectSection_heading__LgvRK"};